import { Space } from 'antd';
import React from 'react';

import { BooleanSelectFilter } from '../../components/BooleanSelectFilter';
import { BrandSelectFilter } from '../../components/BrandSelectFilter';
import { CategorySelectFilter } from '../../components/CategorySelectFilter';

export const ProductFilters: React.FC = () => {
  return (
    <Space wrap>
      <BrandSelectFilter />
      <CategorySelectFilter />
      <BooleanSelectFilter name="isActive" placeholder="Активний" />
      <BooleanSelectFilter name="isNew" placeholder="Новий" />
    </Space>
  );
};
